var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-add-ons-form__date-without-interval" },
    [
      _c(
        "ul",
        { staticClass: "form" },
        _vm._l(_vm.options, function (option, index) {
          return _c("li", { key: index, staticClass: "option" }, [
            _c("input", {
              attrs: {
                id: option.startTime,
                name: "preferred-date",
                type: _vm.addOn.singleSelectDatePicker ? "radio" : "checkbox",
                "aria-label": _vm.getDay(option.startTime),
              },
              domProps: {
                value: option.startTime,
                checked: _vm.selectedAddOnDates.includes(option.startTime),
              },
              on: {
                change: function ($event) {
                  return _vm.updateSelectedDates(option.startTime)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: option.startTime } }, [
              _c("div", { staticClass: "add-on-card-button-container" }, [
                _c("span", { staticClass: "icon-clock" }),
                _vm._v(" "),
                _c("span", { staticClass: "label-text" }, [
                  _vm._v(_vm._s(_vm.getDay(option.startTime))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "icon-checkmark-gold" }),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }